var _circle, _circle2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAwardBadge = function SvgAwardBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ADCCFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.833,
    stroke: "#18181B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#award-badge_svg__clip0_2_508)",
    fill: "#18181B"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 13.5a3.75 3.75 0 115.832 3.12.625.625 0 00-.1.064A3.75 3.75 0 0112.25 13.5zm5.616 4.64A4.988 4.988 0 0116 18.5c-.66 0-1.29-.128-1.866-.36l-.469 3.532 2.013-1.208a.625.625 0 01.643 0l2.014 1.208-.469-3.532zm-4.904-.668a5 5 0 116.076 0l.707 5.32a.625.625 0 01-.942.619L16 21.729l-2.803 1.682a.625.625 0 01-.942-.618l.707-5.321z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13.5,
    r: 4.167
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "award-badge_svg__clip0_2_508"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6 6)",
    d: "M0 0h20v20H0z"
  })))));
};

export default SvgAwardBadge;